import Color from '@styles/Color';
import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';

import InputValidMessage from '@components/dataDisplay/InputValidMessage';
import EyeCloseIcon from '@components/dataDisplay/Icons/EyeCloseIcon';
import EyeIcon from '@components/dataDisplay/Icons/EyeIcon';
import {
  baseInputStyle,
  defaultInputStyle,
  validInputStyle,
} from '../InputStyle';

const focusInput = css`
  border: 1px solid var(--primaryColor);
`;

const PasswordInputBase = styled.div<{
  isValid?: boolean;
  disabled?: boolean;
  block?: boolean;
  isFocus?: boolean;
}>`
  width: 100%;
  ${baseInputStyle}
  ${({ isFocus }) => isFocus && focusInput}
  ${({ isValid }) => (!isValid ? defaultInputStyle : validInputStyle)};

  input {
    flex: 1;
  }
`;

const CustomPasswordInput = styled.input`
  font-family: var(--defaultFontFamily);
  color: var(--textColor);
  font-size: var(--textSize);
  outline: none;

  &::placeholder {
    color: var(--subTextColor);
  }
`;

const TogglePasswordTypeBtn = styled.button`
  padding: 4px;
  border-radius: var(--cardBorderRadius);
`;

interface PasswordInputProps {
  value: string | number | readonly string[] | undefined;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  isValid?: boolean;
  validMessage?: string;
  name?: string;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement> | undefined;
  block?: boolean;
}

function PasswordInput({
  isValid,
  validMessage,
  maxLength = 100,
  disabled,
  value,
  name,
  placeholder,
  onChange,
  onKeyPress,
  block,
}: PasswordInputProps) {
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const handleFocus = useCallback(() => setIsFocus(true), []);
  const handleBlur = useCallback(() => setIsFocus(false), []);
  const togglePasswordShow = () => setIsPasswordShow(!isPasswordShow);

  return (
    <div style={{ width: '100%' }}>
      <PasswordInputBase
        isValid={isValid}
        disabled={disabled}
        isFocus={isFocus}
      >
        <CustomPasswordInput
          type={!isPasswordShow ? 'password' : 'text'}
          maxLength={maxLength}
          onFocus={handleFocus}
          onBlur={handleBlur}
          value={value}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          onKeyPress={onKeyPress}
        />
        <TogglePasswordTypeBtn onClick={togglePasswordShow}>
          {isPasswordShow ? <EyeIcon /> : <EyeCloseIcon />}
        </TogglePasswordTypeBtn>
      </PasswordInputBase>

      {isValid && validMessage && (
        <InputValidMessage>{validMessage}</InputValidMessage>
      )}
    </div>
  );
}

export default PasswordInput;
